export default __webpack_public_path__ + "static/media/peeCee_ATR.d7c53732.png";